import React from "react";

import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import type { SxProps, Theme } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";

export default function SectionCard(props: {
    title?: string;
    action?: React.ReactNode;
    children: React.ReactNode;
    sx?: SxProps<Theme>;
    contentSX?: SxProps<Theme>;
    hideHeader?: boolean;
}) {
    const { title, action, children, sx, contentSX, hideHeader } = props;

    return (
        <Card
            elevation={0}
            sx={[
                (theme) => ({
                    borderRadius: 2,
                    border: "1px solid",
                    borderColor: alpha(theme.palette.common.white, 0.1),
                    backgroundImage: "none",
                    backgroundColor: theme.palette.background.paper,
                }),
                ...(Array.isArray(sx) ? sx : [sx]),
            ]}
        >
            <CardContent
                sx={[
                    {
                        pt: !hideHeader && title ? 0.5 : 1.25,
                        p: 2,
                    },
                    ...(Array.isArray(contentSX) ? contentSX : [contentSX]),
                ]}
            >
                {!hideHeader && title && (
                    <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
                        {title}
                    </Typography>
                )}
                {children}
            </CardContent>
        </Card>
    );
}
